<component-modal>
  <ng-container title> {{ title() }} </ng-container>
  <ng-container body>
    <component-input
      [label]="label()"
      [formControl]="control"
      [isFocused]="true"
      [required]="required()"
      [errorMessage]="control.hasError('required') && control.touched ? errorMessage() : null"
      (enter)="onSave()" />
  </ng-container>
  <ng-container footer>
    <div class="grid-auto-cols flex-grow-1 gap-3">
      <button type="button" class="btn btn-lg btn-light" (click)="activeModal.close()">Cancel</button>
      <button type="button" class="btn btn-lg btn-primary" (click)="onSave()" [disabled]="control.invalid">
        {{ confirmButtonText() }}
      </button>
    </div>
  </ng-container>
</component-modal>
